import type { IconData } from '@stacksjs/iconify-core'

export const pencilCircle: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M41.887 16.436c1.938-1.939 2.676-4.773 1.022-6.96A22 22 0 0 0 40.86 7.14a22.5 22.5 0 0 0-2.336-2.05c-2.187-1.653-5.021-.915-6.96 1.023L16.127 21.551c-.544.544-.917 1.234-.99 2c-.126 1.298-.241 3.725.022 7.491a1.94 1.94 0 0 0 1.799 1.799c3.766.263 6.193.148 7.492.023c.765-.074 1.455-.447 1.999-.99z\"/><path d=\"M39.548 18.775c-.572-1.265-1.808-3.41-4.36-5.963c-2.552-2.551-4.697-3.788-5.962-4.36m13.747 15.495Q43 24.471 43 25c0 11.046-8.954 20-20 20S3 36.046 3 25S11.954 5 23 5q.53 0 1.053.027\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default pencilCircle
